import axios from 'axios'

export const saveProfileToServer = async (profileData, refreshUserCallback = null) => {
  try {
    await axios.patch('/auth/settings', {
      profilePicture: profileData.profilePicture,
      profileSettings: {
        selectedIcon: profileData.selectedIcon,
        profileType: profileData.profileType,
        raveName: profileData.raveName,
        favoriteFestival: profileData.favoriteFestival,
        favoriteGenre: profileData.favoriteGenre,
        tagline: profileData.tagline
      }
    })

    if (refreshUserCallback) {
      try {
        await refreshUserCallback()
      } catch (error) {
        console.warn('Failed to refresh user data after profile save:', error)
      }
    }
    return true
  } catch (error) {
    console.warn('Error saving profile to server:', error)
    return false
  }
}